import ContentBody from '@op/components/ContentBody';
import { ReportPermissionProvider } from '@op/components/ReportPermission';
import React from 'react';
import { Layout, TabPanel, Tabs } from 'tea-component';
import { connect } from 'umi';
import SavedAnalysisList from './pages/SavedAnalysisList';
import { PAGE_NAME } from '@op/constants/page';
import KeywordCardAnalysis from './pages/KeywordCardAnalysis';
import useKeywordTopicPage from './hook/useKeywordTopicPage';
import './scss/page.scss';

const { Content } = Layout;
interface IKeywordAndURLDrill {
  gameInfo: any;
  filter: any;
  wholeGameInfo: any;
  userInfo: any;
}

const KeywordAndURLDrill = ({
  gameInfo,
  wholeGameInfo,
  userInfo,
}: IKeywordAndURLDrill) => {
  const {
    tabs,
    handleChangeTab,
    initialSecondSegment,
    initialOwner,
    activeId,
    onActive,
    formatMessage,
  } = useKeywordTopicPage();

  return (
    <ReportPermissionProvider
      notificationMode={activeId === 'savedAnalysisList' ? 'list' : 'create'}
    >
      <Content className="dbo-page dbo-page-keyword-url-drill">
        <ContentBody
          pageName={PAGE_NAME.KEYWORD_ANALYSIS}
          contentHeard={
            <Content.Header
              className="dbo-header  contentHead-normal"
              title={formatMessage({ id: PAGE_NAME.KEYWORD_ANALYSIS })}
            >
              <div className="header-tab">
                <Tabs
                  ceiling
                  tabs={tabs}
                  animated={false}
                  activeId={activeId}
                  onActive={onActive}
                />
              </div>
            </Content.Header>
          }
        >
          <Tabs
            ceiling
            tabs={tabs}
            className="dbo-hide-tabs dbo-header-tab"
            animated={false}
            destroyInactiveTabPanel={false}
            activeId={activeId}
            onActive={onActive}
          >
            <TabPanel id="createAnalysis">
              <KeywordCardAnalysis
                gameInfo={gameInfo}
                userInfo={userInfo}
                wholeGameInfo={wholeGameInfo}
                changeTab={handleChangeTab}
              ></KeywordCardAnalysis>
            </TabPanel>
            {activeId === 'savedAnalysisList' && (
              <TabPanel id="savedAnalysisList">
                <SavedAnalysisList
                  gameInfo={gameInfo}
                  wholeGameInfo={wholeGameInfo}
                  needRequest={activeId === 'savedAnalysisList'}
                  categoryType="keyword"
                  showSegment
                  initialSecondSegment={initialSecondSegment}
                  initialOwner={initialOwner}
                ></SavedAnalysisList>
              </TabPanel>
            )}
          </Tabs>
        </ContentBody>
      </Content>
    </ReportPermissionProvider>
  );
};

export default connect((state: any) => {
  const { opinionCommon, home } = state;
  return {
    gameInfo: opinionCommon.gameInfo,
    wholeGameInfo: opinionCommon.wholeGameInfo,
    userInfo: home.userInfo,
  };
})(KeywordAndURLDrill);
